import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// NOTE: the generated `attachSupabaseAuth` function middleware is intentionally
// NOT registered. This site has no end-user authentication and no server
// function uses `requireSupabaseAuth`, so the middleware only had the effect of
// pulling the whole @supabase/supabase-js client (auth-js, realtime, storage,
// phoenix) into the client entry bundle — ~350 KiB of JavaScript that never
// ran. Re-add it here if user auth or a protected server function is added.
export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
}));
